var React = require('react');

function Lock (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M29.738 12.361h-.557C28.467 9.049 25.522 6.557 22 6.557s-6.467 2.492-7.18 5.804h-.557a6.19 6.19 0 0 0-6.19 6.19v9.286a6.19 6.19 0 0 0 6.19 6.19h15.476a6.19 6.19 0 0 0 6.19-6.19v-9.286a6.191 6.191 0 0 0-6.191-6.19zM22 8.878c2.231 0 4.105 1.469 4.762 3.482h-9.523c.657-2.013 2.531-3.482 4.761-3.482zm12.257 18.959a4.524 4.524 0 0 1-4.519 4.519H14.262a4.524 4.524 0 0 1-4.519-4.519v-9.286a4.524 4.524 0 0 1 4.519-4.519h15.476a4.524 4.524 0 0 1 4.519 4.519v9.286z","key":0}),React.createElement("path",{"d":"M25.611 20.615a3.611 3.611 0 0 0-7.222 0c0 1.438.847 2.669 2.064 3.25v5.519h3.095v-5.519a3.602 3.602 0 0 0 2.063-3.25z","key":1}),React.createElement("path",{"fill":"none","d":"M0 0h44v44H0z","key":2})]);
}

Lock.defaultProps = {"viewBox":"0 0 44 44"};

module.exports = Lock;

Lock.default = Lock;
